import type { DeepPartial } from '@luna/utils-ts';

import type { Pay } from './Pay';

export const RO: DeepPartial<Pay> = {};
